import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const EventGrid = ({
  title,
  events = [],
  limit = 5,
  showViewAll,
}) => {
  const navigate = useNavigate();
  const [startIndex, setStartIndex] = useState(0);

  if (!Array.isArray(events) || events.length === 0) return null;

  const handleClick = (id) => {
    navigate(`/eventdetails/${id}`);
  };

  const handleViewAll = () => {
    navigate("/events", {
      state: {
        events,
        title,
      },
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);

    return date.toLocaleDateString("en-IN", {
      weekday: "short",
      day: "2-digit",
      month: "short",
    });
  };

  // 👇 If showViewAll exists → use sliding logic
  // 👇 If not (View All page) → show all events
  const visibleEvents = showViewAll
    ? events.slice(startIndex, startIndex + limit)
    : events;

  const nextEvent = () => {
    if (startIndex + limit < events.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const prevEvent = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  return (
    <div className="px-0 py-6">
      {title && (
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">{title}</h2>

          {showViewAll && events.length > limit && (
            <div
              onClick={handleViewAll}
              className="px-4 py-1.5 bg-stone-300 rounded-lg
                         inline-flex justify-center items-center gap-1.5
                         cursor-pointer hover:bg-stone-400 transition"
            >
              <div className="text-black text-ml font-medium uppercase tracking-wide">
                View All
              </div>
            </div>
          )}
        </div>
      )}

      <div className="relative">

        {/* Left Arrow (Home page only) */}
        {showViewAll && startIndex > 0 && (
          <button
            onClick={prevEvent}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10
                             bg-white/60 hover:bg-white/80
                             shadow-md
                             rounded-full
                             w-10 h-10
                             flex items-center justify-center
                             transition
                       "
          >
            ◀
          </button>
        )}

        {/* Right Arrow (Home page only) */}
        {showViewAll && startIndex + limit < events.length && (
          <button
            onClick={nextEvent}
            className="absolute right-3 top-1/2 -translate-y-1/2 z-10
                                      bg-white/60 hover:bg-white/80
                                      shadow-md
                                      rounded-full
                                      w-10 h-10
                                      flex items-center justify-center
                                      transition"
          >
            ▶
          </button>
        )}

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
          {visibleEvents.map((event, index) => {
            const data = event.eventData;
            if (!data) return null;

            const eventDate =
              event.eventVenueSchedules?.[0]?.venueSchedules?.[0]
                ?.eventEndDateTime;

            return (
              <div
                key={data.eventId || index}
                className="cursor-pointer flex flex-col items-center"
                onClick={() => handleClick(data.eventId)}
              >
                <div className="relative w-full h-[300px] overflow-hidden shadow rounded-lg hover:shadow-md transition">
                  <img
                    src={
                      data.imageList?.[0]?.imageUrl ||
                      "https://kokaki-images.s3.amazonaws.com/uploads%2Fimage+%285%29.png"
                    }
                    alt={data.eventName}
                    className="w-full h-full object-cover"
                  />

                  {eventDate && (
                    <div className="absolute bottom-0 left-0 w-full bg-black/70 text-white text-xs py-1 font-medium">
                      <span className="pl-3">
                        {formatDate(eventDate)}
                      </span>
                    </div>
                  )}
                </div>

                <div className="mt-2 text-sm font-medium text-left line-clamp-2 w-full">
                  {data.eventName}
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </div>
  );
};

export default EventGrid;